import * as React from "react";

import { useMemo, useContext, useState } from "react";
import { translation } from "../Dictionary";
import { AppContext } from "../../contextProviders/AppContext";
import { addDays } from "date-fns";

import DatePickerFixedTimeframe from "./DateSingleDay";
import DatePickerFixedDuration from "./DateFixedDuration";
import DefaultDatePicker from "./DefaultDatePicker";
import DatePickerPredetermined from "./DatePickerPredetermined";

const localeText = {
  fieldMonthPlaceholder: (params) =>
    params.contentType === "letter" ? "YYYY" : "KK",
  fieldDayPlaceholder: () => "PP",
  fieldYearPlaceholder: (params) => "V".repeat(params.digitAmount),
};

export default function SelectDate(props) {
  const { companyOpenHours, contentHeigth, companyOpenHoursReturn } = props;
  const {
    selectedPicker,
    setSelectedPicker,
    FEATURE_DISABLE_MULTIDAY,
    startDateString,
    FEATURE_OPTIONAL_FIXED_RESERVATION_DURATION,
    VUOKRAAPAKU_SPECIAL_COMPANY,
    FEATURE_FIXED_RESERVATION_DURATION,
    FEATURE_DISABLE_START_DAYS_FROM_NOW,
    FEATURE_DISABLE_SAME_DAY,
    FEATURE_PREDETERMINED_RESERVATION_RETURNTIME,
    useSpecificPickupReturnCompany,
    groups,
    language,
  } = useContext(AppContext);

  const startTimeLabel = useMemo(() => {
    const group = groups?.[0];
    if (group === "gnista") {
      return translation.get(language, "Timepicker start title accommodation");
    } else {
      return translation.get(language, "Timepicker start title");
    }
  }, [groups, language]);

  const returnTimeLabel = useMemo(() => {
    const group = groups?.[0];
    if (group === "gnista") {
      return translation.get(language, "Timepicker return title accommodation");
    } else {
      return translation.get(language, "Timepicker return title");
    }
  }, [groups, language]);

  const [openDateRangeMobile, setOpenDateRangeMobile] = useState(false);

  const getMinimumDate = () => {
    let date = new Date();
    if (FEATURE_DISABLE_SAME_DAY) {
      // Get tomorrow
      date = addDays(date, 1);
    }

    return date;
  };

  if (FEATURE_OPTIONAL_FIXED_RESERVATION_DURATION) {
    return (
      <DatePickerPredetermined
        contentHeigth={contentHeigth}
        selectedPicker={selectedPicker}
        setSelectedPicker={setSelectedPicker}
        companyOpenHours={companyOpenHours}
        companyOpenHoursReturn={companyOpenHoursReturn}
        getMinimumDate={getMinimumDate}
        openDateRangeMobile={openDateRangeMobile}
        returnTimeLabel={returnTimeLabel}
        setOpenDateRangeMobile={setOpenDateRangeMobile}
        startDateString={startDateString}
        startTimeLabel={startTimeLabel}
        VUOKRAAPAKU_SPECIAL_COMPANY={VUOKRAAPAKU_SPECIAL_COMPANY}
        localeText={localeText}
      />
    );
  }

  if (FEATURE_PREDETERMINED_RESERVATION_RETURNTIME) {
    console.log("FEATURE_PREDETERMINED_RESERVATION_RETURNTIME ACTIVE");
    return (
      <DatePickerFixedTimeframe
        contentHeigth={contentHeigth}
        getMinimumDate={getMinimumDate}
        selectedPicker={selectedPicker}
        setSelectedPicker={setSelectedPicker}
        localeText={localeText}
      />
    );
  }

  // Single day picker
  if (FEATURE_DISABLE_MULTIDAY) {
    console.log("FEATURE_DISABLE_MULTIDAY ACTIVE");
    return (
      <DatePickerFixedTimeframe
        contentHeigth={contentHeigth}
        getMinimumDate={getMinimumDate}
        selectedPicker={selectedPicker}
        setSelectedPicker={setSelectedPicker}
        localeText={localeText}
      />
    );
  }

  // Single date desktop reservation schedule with fixed duration
  if (FEATURE_FIXED_RESERVATION_DURATION) {
    console.log("FEATURE_FIXED_RESERVATION_DURATION ACTICE");
    return (
      <DatePickerFixedDuration
        contentHeigth={contentHeigth}
        selectedPicker={selectedPicker}
        setSelectedPicker={setSelectedPicker}
        localeText={localeText}
      />
    );
  }

  // default time picker with no features

  return (
    <DefaultDatePicker
      contentHeigth={contentHeigth}
      selectedPicker={selectedPicker}
      setSelectedPicker={setSelectedPicker}
      companyOpenHours={companyOpenHours}
      companyOpenHoursReturn={companyOpenHoursReturn}
      getMinimumDate={getMinimumDate}
      openDateRangeMobile={openDateRangeMobile}
      returnTimeLabel={returnTimeLabel}
      setOpenDateRangeMobile={setOpenDateRangeMobile}
      startDateString={startDateString}
      startTimeLabel={startTimeLabel}
      VUOKRAAPAKU_SPECIAL_COMPANY={VUOKRAAPAKU_SPECIAL_COMPANY}
      localeText={localeText}
    />
  );
}
